'use strict';

module.exports = {
    FORM_DEFINITION_REQUEST: 'FORM_DEFINITION_REQUEST',
    FORM_DEFINITION_RESPONSE: 'FORM_DEFINITION_RESPONSE',
    FORM_SUBMISSION: 'FORM_SUBMISSION',
    FORM_SUBMISSION_FAILED: 'FORM_SUBMISSION_FAILED',
    FORM_DEFINITION_RENDERED_DIMENSIONS: 'FORM_DEFINITION_RENDERED_DIMENSIONS'
};